import { Station } from "api";
import { useCallback } from "react";

interface UseMapCameraOptions {
    defaultCenter?: { lat: number; lng: number }
    minZoomToShowLabel?: number
    specificLocationZoom?: number
}

export const useMapCamera = ({
    defaultCenter = { lat: 31.9648616, lng: 34.9004544 },
    minZoomToShowLabel = 13,
    specificLocationZoom = 16
}: UseMapCameraOptions = {}) => {

    const focusOnSpecificLocation = useCallback((
        map: google.maps.Map | null,
        lat: number,
        lon: number
    ) => {
        if (!map) return

        map.setCenter({ lat, lng: lon })
        map.setZoom(specificLocationZoom)
    }, [specificLocationZoom])

    const focusOnCity = useCallback((
        map: google.maps.Map | null,
        latitude: number,
        longitude: number
    ) => {
        if (!map) return

        map.setCenter({ lat: latitude, lng: longitude })
        map.setZoom(minZoomToShowLabel)
    }, [minZoomToShowLabel])

    const focusOnQueryLocation = useCallback((
        map: google.maps.Map | null,
        locationLat?: number,
        locationLng?: number
    ) => {
        if (!map || (!locationLat && !locationLng)) return

        map.setCenter({
            lat: locationLat || defaultCenter.lat,
            lng: locationLng || defaultCenter.lng,
        })
        map.setZoom(minZoomToShowLabel)
    }, [defaultCenter, minZoomToShowLabel])

    const fitStationsBounds = useCallback((
        map: google.maps.Map | null,
        stations: Station[],
        applyZoomConstraints?: (map: google.maps.Map) => void
    ) => {
        if (!map || stations.length === 0) return

        const bounds = new window.google.maps.LatLngBounds()
        stations.forEach((station) =>
            bounds.extend(new window.google.maps.LatLng(
                station.geoLocation.latitude,
                station.geoLocation.longitude
            ))
        )

        map.fitBounds(bounds)

        if (applyZoomConstraints) {
            applyZoomConstraints(map)
        }
    }, [])

    return {
        focusOnSpecificLocation,
        focusOnCity,
        focusOnQueryLocation,
        fitStationsBounds
    }
}
